export const DeleteIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_delete)">
        <path
          d="M7.63936 19C7.63936 20.1 8.55181 21 9.66701 21H16.3786C17.4938 21 18.4062 20.1 18.4062 19V9C18.4062 7.9 17.4938 7 16.3786 7H9.66701C8.55181 7 7.63936 7.9 7.63936 9V19ZM19.6836 7H16.9899L16.2165 6.24C16.0431 6.07 15.7998 6 15.5666 6H10.479C10.2458 6 10.0025 6.07 9.82911 6.24L9.05568 7H6.36194C5.87531 7 5.48062 7.39 5.48062 7.87C5.48062 8.35 5.87531 8.74 6.36194 8.74H7.13537V19C7.13537 20.65 8.31068 22 9.66701 22H16.3786C17.7349 22 18.9102 20.65 18.9102 19V8.74H19.6836C20.1702 8.74 20.5649 8.35 20.5649 7.87C20.5649 7.39 20.1702 7 19.6836 7Z"
          fill="#152c70"
        />
      </g>
      <defs>
        <clipPath id="clip0_delete">
          <rect
            width="24.3318"
            height="24"
            fill="white"
            transform="translate(0.856934)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};